<template>
  <generic-modal :title="$t('chatbot')" ref="generic_modal" size="fullscreen">
    <div class="columns is-3">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">{{ $t("start message direction") }}</label>
          <div class="select">
            <select v-model="meta.settings.start_message_direction">
              <option value="inbound">{{ $t("inbound") }}</option>
              <option value="outbound">{{ $t("outbound") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("message regular expression") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.settings.message_regular_expression"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="title is-5">{{ $t("flow") }}</div>
    <div ref="process_container" class="editor-container"></div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-rounded is-primary"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <div class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </div>
    </template>
    <configure-modal ref="configure_modal" @success="update_component" />
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  generate_error_message_text,
  get,
  error_message,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import ConfigureModal from "./configure_modal/Index.vue";
import BpmnModeler from "bpmn-js/lib/Modeler";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
import "bpmn-js/dist/assets/bpmn-js.css";
import "bpmn-js/dist/assets/diagram-js.css";

export default {
  name: "ChatbotModal",
  components: { GenericModal, ConfigureModal },
  props: {},
  data() {
    return {
      meta: { settings: {} },
      modeler: null,
      components: [],
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      if (!v.modeler) v.init_modeler();
      v.set_default_model();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      if (!v.modeler) v.init_modeler();

      v.$root.loader(true);
      get("/whatsapp/chatbot", { uuid: uuid })
        .then((res) => {
          v.meta = res;

          if (v.meta.settings.xml) {
            v.modeler
              .importXML(v.meta.settings.xml)
              .then(() => {
                setTimeout(() => {
                  let svgs = window.jQuery(".editor-container svg:last");
                  svgs.addClass("svgprocess");
                }, 500);
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            v.set_default_model();
          }

          if (res.settings.components) {
            // console.log("res.settings.components", res.settings.components);
            setTimeout(() => {
              res.settings.components.forEach((c) => {
                let trgt = v.components.find((c2) => c2.id == c.id);
                if (trgt) {
                  trgt.name = c.name;
                  trgt.settings = c.settings;
                }
              });
            }, 1000);
          }
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = { settings: {} };
      v.error = "";
      v.components = [];
      // if (v.modeler) v.modeler.clear();
    },
    save() {
      let v = this;

      /** Modeler data */
      v.modeler
        .saveXML({ format: true })
        .then((xml) => {
          v.meta.settings.xml = xml.xml;
          v.meta.settings.components = v.components;
          let data = { ...v.meta };
          if (data.uuid) {
            post("/whatsapp/chatbot", data)
              .then(() => {
                v.$emit("success");
                v.$refs.generic_modal.close_modal();
              })
              .catch((error) => {
                v.error = generate_error_message_text(error);
              })
              .finally(() => {});
          } else {
            put("/whatsapp/chatbot", data)
              .then(() => {
                v.$emit("success");
                v.$refs.generic_modal.close_modal();
              })
              .catch((error) => {
                v.error = generate_error_message_text(error);
              })
              .finally(() => {});
          }

          // let collaboration = currentDefinitions.rootElements.find(
          //   (e) => e.$type == "bpmn:Collaboration"
          // );
        })
        .catch((err) => {
          console.error("error saving process", err);
        });
    },
    init_modeler() {
      let v = this;
      v.modeler = new BpmnModeler({
        container: v.$refs.process_container,
      });

      var eventBus = v.modeler.get("eventBus");
      eventBus.on("element.dblclick", function (event) {
        let component = v.components.find((c) => c.id == event.element.id);
        let elmnt = event.element.businessObject;
        elmnt.settings = component ? component.settings : {};
        // console.log("elmnt", elmnt);
        let cpy = JSON.parse(JSON.stringify(elmnt));
        v.confgure_element(cpy);
      });

      // eventBus.on("element.changed", function (event) {
      //   console.log("element changed", event);
      //   // let element = event.element;
      //   // let component = v.components.find((c) => c.id == element.id);
      //   // if (component) {
      //   //   component.name = element.businessObject.name;
      //   // }
      // });

      eventBus.on("element.updateProperties", function (event) {
        console.log("element updateProperties", event);
      });
      eventBus.on("shape.added", function (event) {
        let businessObject = event.element.businessObject;
        let trgt = v.components.find((c) => c.id == businessObject.id);
        if (!trgt) v.components.push(businessObject);
      });
      // eventBus.on("shape.changed", function (event) {
      //   console.log("shape changed", event);
      // });
      eventBus.on("shape.removed", function (event) {
        let businessObject = event.element.businessObject;
        let trgt = v.components.find((c) => c.id == businessObject.id);
        if (trgt) v.components = v.components.filter((c) => c.id != trgt.id);
      });
    },
    set_default_model() {
      let v = this;
      // console.log("setting default model");
      get("/whatsapp/chatbot/default", {})
        .then((response) => {
          response = response.replace(/PROCESS_NAME/g, v.$t("chatbot"));
          v.modeler
            .importXML(response)
            .then(() => {
              setTimeout(() => {
                let svgs = window.jQuery(".editor-container svg:last");
                svgs.addClass("svgprocess");
              }, 500);
            })
            .catch((err) => {
              console.error("error rendering process", err);
              error_message(err);
            });
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        });
    },
    confgure_element(element) {
      let v = this;
      v.$refs.configure_modal.show_modal(element);
    },
    update_component(data) {
      // console.log("update_component", data);
      let v = this;
      let trgt = v.components.find((c) => c.id == data.id);
      if (trgt) {
        trgt.name = data.name;
        trgt.settings = data.settings;
        if (trgt.$type != data.$type) trgt.$type = data.$type;
      } else v.components.push(data);

      if (data.name) {
        let modeling = v.modeler.get("modeling");
        const elementRegistry = v.modeler.get("elementRegistry");
        let trgt = elementRegistry.get(data.id);

        modeling.updateProperties(trgt, {
          name: data.name,
        });
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
